export const validateForm = (formData, tabType) => {
  const errors = {};
  if (tabType !== "item" && formData.code && formData.code.length > 20) {
    errors.code = "Code should not exceed 20 characters";
  }

  if (tabType === "supplier") {
    const name = (formData.name || "").trim();
    const mobile = (formData.mobile || "").trim();
    const address = (formData.address || "").trim();
    const email = (formData.email || "").trim();
    const bankIfsc = (formData.bankIfsc || "").trim().toUpperCase();
    const bankAccountNo = (formData.bankAccountNo || "").trim();
    const gstNo = (formData.gstNo || "").trim().toUpperCase();

    if (!name || name.length < 2) {
      errors.name = "Name is required and must be at least 2 characters";
    }
    if (!mobile || !/^\d{10}$/.test(mobile.replace(/\D/g, ""))) {
      errors.mobile = "Valid 10-digit mobile number is required";
    }
    if (!address || address.length < 5) {
      errors.address = "Address is required";
    }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Please enter a valid email address";
    }
    if (!formData.openingDate) {
      errors.openingDate = "Opening date is required";
    }
    if (!formData.state) {
      errors.state = "State is required";
    }
    if (!formData.district) {
      errors.district = "District is required";
    }
    if (!formData.gstRegisteredType) {
      errors.gstRegisteredType = "GST registered type is required";
    }
    if (
      gstNo &&
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstNo)
    ) {
      errors.gstNo = "Please enter a valid GST number";
    }
    if (bankIfsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(bankIfsc)) {
      errors.bankIfsc = "Please enter a valid IFSC code";
    }
    if (bankAccountNo && !/^\d{9,18}$/.test(bankAccountNo)) {
      errors.bankAccountNo = "Please enter a valid account number";
    }
  } else if (tabType === "registeredType") {
    if (!formData.title || formData.title.trim().length < 2) {
      errors.title = "Type name is required and must be at least 2 characters";
    }
    if (formData.description && formData.description.length > 500) {
      errors.description = "Description should not exceed 500 characters";
    }
  } else if (tabType === "item") {
    if (!formData.type) {
      errors.type = "Item type is required";
    }
    if (!formData.category) {
      errors.category = "Category selection is required";
    }
    if (!formData.quality) {
      errors.quality = "Quality is required";
    }
    if (!formData.brand) {
      errors.brand = "Brand selection is required";
    }
    if (!formData.itemName || formData.itemName.trim().length < 2) {
      errors.itemName = "Item name is required and must be at least 2 characters";
    }
    formData.name = formData.itemName;
    if (formData.itemCode && formData.itemCode.length > 20) {
      errors.itemCode = "Item code should not exceed 20 characters";
    }
    if (formData.isUnique && !formData.uniqueName) {
      errors.uniqueName = "Unique name is required when item is marked as unique";
    }
    if (!formData.units) {
      errors.units = "Units are required";
    }
    if (!formData.fixingType) {
      errors.fixingType = "Fixing Type is required";
    }
    if (!formData.moq || isNaN(formData.moq) || formData.moq <= 0) {
      errors.moq = "Valid MOQ is required";
    }
  } else if (tabType === "stores") {
    if (!formData.title || formData.title.trim().length < 2) {
      errors.title = "Store Name is required and must be at least 2 characters";
    }
    if (formData.code && formData.code.trim().length < 2) {
      errors.code = "Store Code must be at least 2 characters if provided";
    }
    if (!formData.address || formData.address.trim().length < 5) {
      errors.address = "Store Address is required (min 5 characters)";
    }
    if (
      formData.mobile &&
      !/^\d{10}$/.test(formData.mobile.replace(/\D/g, ""))
    ) {
      errors.mobile = "If provided, mobile must be a valid 10-digit number";
    }
  } else {
    if (!formData.title || formData.title.trim().length < 2) {
      errors.title = "Title is required and must be at least 2 characters";
    }
    if (formData.description && formData.description.length > 500) {
      errors.description = "Description should not exceed 500 characters";
    }
  }

  return errors;
};
